import { Component, OnInit } from '@angular/core';
import { AuthService } from '@auth-suite-services/services';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.scss']
})
export class UnauthorizedComponent implements OnInit {
  // tslint:disable-next-line:variable-name
  constructor(private _authService: AuthService) {}

  ngOnInit(): void {}
}
